import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cca6a356"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "multi-table-root" }
const _hoisted_2 = {
  key: 0,
  class: "multi-table-content"
}
const _hoisted_3 = { class: "header" }
const _hoisted_4 = { class: "table-name" }
const _hoisted_5 = { class: "shoe-juno" }
const _hoisted_6 = { class: "red-limit" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "drop-down-icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.828",
    height: "6.828",
    viewBox: "0 0 10.828 6.828"
  }, [
    /*#__PURE__*/_createElementVNode("g", {
      id: "Component_15_1",
      "data-name": "Component 15 – 1",
      transform: "translate(9.414 1.414) rotate(90)"
    }, [
      /*#__PURE__*/_createElementVNode("line", {
        id: "Line_46",
        "data-name": "Line 46",
        x2: "4",
        y2: "4",
        fill: "none",
        stroke: "#393026",
        "stroke-linecap": "round",
        "stroke-width": "2"
      }),
      /*#__PURE__*/_createElementVNode("line", {
        id: "Line_47",
        "data-name": "Line 47",
        y1: "4",
        x2: "4",
        transform: "translate(0 4)",
        fill: "none",
        stroke: "#393026",
        "stroke-linecap": "round",
        "stroke-width": "2"
      })
    ])
  ])
], -1))
const _hoisted_8 = { class: "video-group" }
const _hoisted_9 = ["id"]
const _hoisted_10 = ["id"]
const _hoisted_11 = {
  key: 0,
  class: "video-loader"
}
const _hoisted_12 = { class: "game-no" }
const _hoisted_13 = { class: "btn-confirm-cancel-group" }
const _hoisted_14 = { class: "map-summary-group" }
const _hoisted_15 = { class: "road-map-summary" }
const _hoisted_16 = ["data-label"]
const _hoisted_17 = ["data-label"]
const _hoisted_18 = ["data-label"]
const _hoisted_19 = ["data-label"]
const _hoisted_20 = ["data-label"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fill-row" }, null, -1))
const _hoisted_22 = { class: "road-map-area" }
const _hoisted_23 = {
  key: 0,
  class: "multi-card-result"
}
const _hoisted_24 = { class: "meta" }
const _hoisted_25 = { class: "point" }
const _hoisted_26 = { class: "label" }
const _hoisted_27 = { class: "cards" }
const _hoisted_28 = { class: "cards-inner" }
const _hoisted_29 = { class: "cards-top" }
const _hoisted_30 = ["data-color"]
const _hoisted_31 = { class: "meta" }
const _hoisted_32 = { class: "point" }
const _hoisted_33 = { class: "label" }
const _hoisted_34 = { class: "cards" }
const _hoisted_35 = { class: "cards-inner" }
const _hoisted_36 = { class: "cards-top" }
const _hoisted_37 = {
  key: 1,
  class: "shuffling"
}
const _hoisted_38 = {
  key: 0,
  class: "message-prompt"
}
const _hoisted_39 = { class: "message-prompt-container" }
const _hoisted_40 = { class: "message-msgbox-title-wrap" }
const _hoisted_41 = { class: "title" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bar-line" }, null, -1))
const _hoisted_43 = { class: "message-body-wrap" }
const _hoisted_44 = { class: "btn-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_drop_down_2 = _resolveComponent("drop-down-2")!
  const _component_count_down_timer = _resolveComponent("count-down-timer")!
  const _component_bet_group = _resolveComponent("bet-group")!
  const _component_d_prediction_1 = _resolveComponent("d-prediction-1")!
  const _component_roadmap = _resolveComponent("roadmap")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.desk !== undefined)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.tableName), 1),
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.showAndJuNo), 1),
            _createElementVNode("div", _hoisted_6, [
              _createTextVNode(_toDisplayString(_ctx.t('multibetting.redlimit')) + " ", 1),
              _createVNode(_component_drop_down_2, {
                class: "drop-down",
                placeHolder: _ctx.redLimit,
                listData: _ctx.limitData,
                modelValue: -1
              }, {
                icon: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }, 8, ["placeHolder", "listData"])
            ]),
            _createElementVNode("div", {
              class: "remove btn",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('remove', _ctx.position)))
            }, _toDisplayString(_ctx.t('multibetting.remove')), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("canvas", {
              ref: "videoRef1",
              id: `_video${_ctx.position}`,
              class: "bn1"
            }, null, 8, _hoisted_9),
            _createElementVNode("canvas", {
              ref: "videoRef2",
              id: `_video_${_ctx.position}`,
              class: "bn2"
            }, null, 8, _hoisted_10),
            (_ctx.videoIsLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.t('game.gameid')) + ":" + _toDisplayString(_ctx.gameNo), 1),
            (_ctx.isBaccaratTable && (_ctx.rebateType !== 1 && _ctx.rebateType !== 3) && _ctx.enableFreeBaccarat)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(["btn-toggle-game-mode", { disabled: !_ctx.allowToggleGameMode }])
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass({ active: !_ctx.isFreeBaccarat }),
                    onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.tooggleGameMode(false)), ["prevent"]))
                  }, _toDisplayString(_ctx.t('game.baccarat')), 3),
                  _createElementVNode("div", {
                    class: _normalizeClass({ active: _ctx.isFreeBaccarat }),
                    onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.tooggleGameMode(true)), ["prevent"]))
                  }, _toDisplayString(_ctx.t('game.commissionfreebaccarat')), 3)
                ], 2))
              : _createCommentVNode("", true),
            (_ctx.currentCount !== -1)
              ? (_openBlock(), _createBlock(_component_count_down_timer, {
                  key: 2,
                  class: "timer",
                  count: _ctx.currentCount
                }, null, 8, ["count"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: "enter-table btn",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.enterTable && _ctx.enterTable(...args)))
            }, _toDisplayString(_ctx.t('multibetting.enter')), 1)
          ]),
          _createVNode(_component_bet_group, {
            ref: "refBetGroup",
            class: "bet-group",
            gameType: _ctx.gameType,
            mData: _ctx.desk,
            position: _ctx.position,
            isFreeBaccarat: _ctx.isFreeBaccarat,
            onOnUpdate: _ctx.onPlaceTempBetOrClear,
            onOnBetmodeChange: _ctx.onBetModeChange
          }, null, 8, ["gameType", "mData", "position", "isFreeBaccarat", "onOnUpdate", "onOnBetmodeChange"]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", {
              class: _normalizeClass(["btn-cancel", { btn: _ctx.hasTempBet }]),
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.cancelTempbet && _ctx.cancelTempbet(...args)))
            }, null, 2),
            _createElementVNode("div", {
              class: _normalizeClass(["btn-confirm", { btn: _ctx.hasTempBet }]),
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.confirmTempBet && _ctx.confirmTempBet(...args)))
            }, null, 2)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", {
                class: "road-map-summary-item",
                "data-color": "red",
                "data-label": _ctx.gameType === 1
                        ? _ctx.t('roadmap.banker')
                        : _ctx.t('roadmap.dragon')
                        
              }, _toDisplayString(_ctx.redCount), 9, _hoisted_16),
              _createElementVNode("div", {
                class: "road-map-summary-item",
                "data-color": "blue",
                "data-label": _ctx.gameType === 1
                        ? _ctx.t('roadmap.player')
                        : _ctx.t('roadmap.tiger')
                        
              }, _toDisplayString(_ctx.blueCount), 9, _hoisted_17),
              _createElementVNode("div", {
                class: "road-map-summary-item",
                "data-color": "green",
                "data-label": _ctx.t('roadmap.tie')
              }, _toDisplayString(_ctx.greenCount), 9, _hoisted_18),
              (_ctx.gameType === 1)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "road-map-summary-item",
                    "data-color": "red",
                    "data-label": _ctx.t('roadmap.pair')
                  }, _toDisplayString(_ctx.redPairCount), 9, _hoisted_19))
                : _createCommentVNode("", true),
              (_ctx.gameType === 1)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "road-map-summary-item",
                    "data-color": "blue",
                    "data-label": _ctx.t('roadmap.pair')
                  }, _toDisplayString(_ctx.bluePairCount), 9, _hoisted_20))
                : _createCommentVNode("", true)
            ]),
            _hoisted_21,
            _createVNode(_component_d_prediction_1, {
              class: "d-prediction-1 btn",
              color: 1,
              gameType: _ctx.gameType,
              mapdata: _ctx.nextRedRoadMapSummaryData,
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.predict(1)))
            }, null, 8, ["gameType", "mapdata"]),
            _createVNode(_component_d_prediction_1, {
              class: "d-prediction-1 btn",
              color: 2,
              gameType: _ctx.gameType,
              mapdata: _ctx.nextBlueRoadMapSummaryData,
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.predict(2)))
            }, null, 8, ["gameType", "mapdata"])
          ]),
          _createElementVNode("div", _hoisted_22, [
            (_openBlock(), _createBlock(_component_roadmap, {
              key: _ctx.mapKey,
              ref: "roadmapview12",
              class: "road-map",
              display: 2,
              gameType: _ctx.gameType,
              enablePrediction: true,
              mapData: _ctx.mapData,
              onRoadMapData: _ctx.onRoadMapDataParsed
            }, null, 8, ["gameType", "mapData", "onRoadMapData"]))
          ]),
          (_ctx.showCardDisplay && _ctx.cardSnap)
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                _createElementVNode("div", {
                  class: _normalizeClass(["side left", _ctx.gameType === 2 ? 'red' : 'blue'])
                }, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.gameType === 2 ? _ctx.cardSnap.redTotal : _ctx.cardSnap.blueTotal), 1),
                    _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.gameType === 1 ? _ctx.t('roadmap.player') : _ctx.t('roadmap.dragon')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.gameType === 2 ? _ctx.cardSnap.redCard : _ctx.cardSnap.blueCard).slice(0, 2), (c, i) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: `l-${i}`,
                            class: _normalizeClass(`v_${c}`)
                          }, null, 2))
                        }), 128))
                      ]),
                      ((_ctx.gameType === 2 ? _ctx.cardSnap.redCard : _ctx.cardSnap.blueCard)[2])
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(["cards-bottom", `h_${(_ctx.gameType === 2 ? _ctx.cardSnap.redCard : _ctx.cardSnap.blueCard)[2]}`])
                          }, null, 2))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ], 2),
                _createElementVNode("div", {
                  class: "winner",
                  "data-color": _ctx.cardSnap.whoWin
                }, _toDisplayString(_ctx.cardSnap.label || '-'), 9, _hoisted_30),
                _createElementVNode("div", {
                  class: _normalizeClass(["side right", _ctx.gameType === 2 ? 'blue' : 'red'])
                }, [
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.gameType === 2 ? _ctx.cardSnap.blueTotal : _ctx.cardSnap.redTotal), 1),
                    _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.gameType === 1 ? _ctx.t('roadmap.banker') : _ctx.t('roadmap.tiger')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("div", _hoisted_36, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.gameType === 2 ? _ctx.cardSnap.blueCard : _ctx.cardSnap.redCard).slice(0, 2), (c, i) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: `r-${i}`,
                            class: _normalizeClass(`v_${c}`)
                          }, null, 2))
                        }), 128))
                      ]),
                      ((_ctx.gameType === 2 ? _ctx.cardSnap.blueCard : _ctx.cardSnap.redCard)[2])
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(["cards-bottom", `h_${(_ctx.gameType === 2 ? _ctx.cardSnap.blueCard : _ctx.cardSnap.redCard)[2]}`])
                          }, null, 2))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ], 2)
              ]))
            : _createCommentVNode("", true),
          (_ctx.desk.status === 4)
            ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                _createElementVNode("span", null, _toDisplayString(_ctx.t('game.shuffling')), 1)
              ]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "btn-sellect-table btn",
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('select-table')))
        })),
    _createVNode(_Transition, { name: "fadein-out" }, {
      default: _withCtx(() => [
        (_ctx.showMessageBox)
          ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.t('common.hint')), 1),
                  _createElementVNode("div", {
                    class: "close-btn",
                    onClick: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.kickOutFromTable && _ctx.kickOutFromTable(...args)), ["prevent"]))
                  }),
                  _hoisted_42
                ]),
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.t('prompts.tablecloseforaccess')), 1),
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("div", {
                      class: "btn-confirm",
                      onClick: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.kickOutFromTable && _ctx.kickOutFromTable(...args)), ["prevent"]))
                    }, _toDisplayString(_ctx.t('common.confirm')), 1)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}